import transact from 'src/lib/data/transact'

import dbSlice from 'src/store/db/slice'
import * as boardSelectors from 'src/store/selectors/board'

export const removeDraftPost = draftId => async (dispatch, getState) => {
  const state = getState()
  const boardId = boardSelectors.boardIdSelector(state)

  await transact([['@board/remove-draft-post', { draftId, boardId }]])

  dispatch(dbSlice.actions.removeDraftPost({ boardId, draftId }))
}
